import "./SignInRequests.scss";
import React, { useState } from "react";
import {
    IonPage,
    IonContent,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonTitle,
    IonBackButton,
    IonTabBar,
    IonTabButton,
  } from "@ionic/react";
//   import { useParams } from "react-router-dom";
import SignInAction from "./../../components/SignInAction";
import SignInPending from "./../../components/SignInPending";

const SignInRequests: React.FC = () => {
    // const params: any = useParams();
    // const id = params["id"];
    const [tabValue, setTabValue] = useState<any>("pending");

    const handleClickPending = () => {
        setTabValue("pending");
    }

    const handleClickActioned = () => {
        setTabValue("actioned");
    }

    return (
        <IonPage className="sign-in-requests-page">
            <IonHeader className="ion-no-border" mode="ios">
                <IonToolbar mode="ios">
                    <IonButtons slot="start" style={{marginLeft: "8px"}}>
                    <IonBackButton defaultHref="/requests" text="" />
                    </IonButtons>

                    <IonTitle>Sign In</IonTitle>

                </IonToolbar>
            </IonHeader>
            <IonTabBar slot="top" mode="ios" style={{padding: "0"}}>
                <IonTabButton 
                    tab="pending"
                    selected={tabValue === "pending"}
                    >
                    <div className="tab-title" onClick={handleClickPending}>
                        PENDING
                    </div>
                </IonTabButton>

                <IonTabButton
                    tab="actioned"
                    selected={tabValue === "actioned"}
                 >
                    <div className="tab-title" onClick={handleClickActioned}>
                        ACTIONED
                    </div>
                </IonTabButton>
            </IonTabBar>
            <IonContent>
                {tabValue === "pending" && <SignInPending tabValue={tabValue} />}
                {tabValue === "actioned" && <SignInAction tabValue={tabValue} />}
            </IonContent>
        </IonPage>
    )

};

export default SignInRequests;